export default __webpack_public_path__ + "static/media/ic_send_message_white.f8037220.svg";